import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { FloraFeedbackError, FloraFeedbackPayload, FloraFeedbackResponse } from './flora-feedback-client.type';

const axiosInstance = AxiosInstance();
const floraFeedbackBaseURL = appConfig.VITE_APP_API_URL + '/api/flora-feedback/';

/**
 * Records a user's rating of the most-recent Flora response for the given chat.
 *
 * The endpoint is create-only and rates the chat's latest turn — there is no
 * message id. The rejection preserves the HTTP status so callers can treat a
 * 409 (already submitted for this response) distinctly from other failures.
 *
 * @param {FloraFeedbackPayload} payload - Feedback body. `reasons` must be non-empty for negative sentiment and omitted for positive.
 * @returns {Promise<FloraFeedbackResponse>} The recorded feedback on success (201).
 * @throws {FloraFeedbackError} Rejects with `{ status, data }` on any non-2xx response or network error.
 */
const createFloraFeedback = (payload: FloraFeedbackPayload): Promise<FloraFeedbackResponse> => {
  return axiosInstance
    .post(floraFeedbackBaseURL, payload)
    .then((response) => response.data)
    .catch((error) =>
      Promise.reject<FloraFeedbackError>({
        status: error?.response?.status,
        data: error?.response?.data,
      }),
    );
};

export { createFloraFeedback };
